const s = {
  name: "LoadingLines",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,0v4h-2V0H13z"/>
		<path class="st0" d="M13,24h-2v-4h2V24z"/>
		<path class="st0" d="M19.4,15.1l-1,1.7l3.5,2l1-1.7L19.4,15.1z"/>
		<path class="st0" d="M5.6,16.9l-3.5,2l-1-1.7l3.5-2L5.6,16.9z"/>
		<path class="st0" d="M19.4,8.9l3.5-2l-1-1.7l-3.5,2L19.4,8.9z"/>
		<path class="st0" d="M20,11h4v2h-4V11z"/>
		<path class="st0" d="M4,11H0v2h4V11z"/>
		<path class="st0" d="M18.9,2.1l-2,3.5l-1.7-1l2-3.5L18.9,2.1z"/>
		<path class="st0" d="M6.9,22.9l-1.7-1l2-3.5l1.7,1L6.9,22.9z"/>
		<path class="st0" d="M16.9,18.4l-1.7,1l2,3.5l1.7-1L16.9,18.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as LoadingLines
};
